import { NavLink } from "react-router-dom";
import styles from "./Main.module.scss";
import picture from "./img/Main.jpg";
import pictureTwo from "./img/Main_2.jpg";
import pictureThree from "./img/Main_3.jpg";
import pictureFour from "./img/Main_4.jpg";
import pictureFive from "./img/Main_5.jpg";
import pictureSix from "./img/Main_6.jpg";

import logo from "./img/Logo.png";

function Main() {
  return (
    <div className={styles.container}>
      <div>
        <img className={styles.logo} src={logo} alt="logo" />
      </div>
      <div className={styles.trips}>
        <div className={styles.tripLinks}>
          <h1 className={styles.title}>Learn more about your trip</h1>
          <div className={styles.tripsGrid}>
            {/* change back to display grid when more trips are added */}
            <div className={styles.tripsGridInner}>
              <h2 className={styles.year}>2026</h2>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Scotland/May_20-29">
                  Scotland, May 20 - 29, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="England/June_1-11-26">
                  England, June 1 - 11, 2026
                </NavLink>
              </div>
              {/* <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Poland/August-26">
                  Poland, August 17 - 27, 2026
                </NavLink>
              </div> */}
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Ireland/September-26">
                  Ireland, September 14 - 23, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/September-2026">
                  Israel & Petra, September 29 - October 13, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/October-2026">
                  Israel, October 20 - 30, 2026
                </NavLink>
              </div>
              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/November-2026">
                  Israel & Petra, November 2 - 16, 2026
                </NavLink>
              </div>
            </div>
            <div className={styles.tripsGridInner}>
              <h2 className={styles.year}>2027</h2>

              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Germany/May-2027">
                  Germany, May 4 - 15, 2027
                </NavLink>
              </div>

              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/June-2027">
                  Israel / GBS, May 24 - June 4, 2027
                </NavLink>
              </div>

              <div className={styles.listItem}>
                <div className={styles.circle}></div>
                <NavLink to="Greece/June-2027">
                  Greece, June 8 - 19, 2027
                </NavLink>
              </div>
              <div className={styles.listItemPossible}>
                <div className={styles.circle}></div>
                <NavLink to="Switzerland/September-2027">
                  Switzerland, September 22 - October 1, 2027
                </NavLink>
              </div>
              <div className={styles.listItemPossible}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/October-2027">
                  Israel & Petra, October 22 - November 5, 2027
                </NavLink>
              </div>
              <div className={styles.listItemPossible}>
                <div className={styles.circle}></div>
                <NavLink to="Israel/November-2027">
                  Israel & Petra, November 8 - 22, 2027
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.pictures}>
        <div className={styles.pictureBox}>
          <img src={picture} alt="Jerusalem" />
        </div>
        <div className={styles.pictureBox}>
          <img src={pictureTwo} alt="Jazreel valley" />
        </div>
        <div className={styles.pictureBox}>
          <img src={pictureFour} alt="Coliseum in Caesarea" />
        </div>
        <div className={styles.extraPicture}>
          <img src={pictureThree} alt="The Sea of Galilee" />
        </div>
      </div>
      <div className={styles.otherTrips}>
        <h2 className={styles.possibleTripsTitle}>Possible trips</h2>
        <div className={styles.possibleTrips}>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Switzerland/trip">Switzerland</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Israel/trip">Israel</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Poland/trip">Poland</NavLink>
          </div>{" "}
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Greece/trip">Greece</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Germany/trip">Germany</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Italy/trip">Italy</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Patmos/trip">Patmos</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Turkey/trip">Turkey</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="England/trip">England</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Scotland/trip">Scotland</NavLink>
          </div>
          <div className={styles.listItemPossible}>
            <div className={styles.circle}></div>
            <NavLink to="Ireland/trip">Ireland</NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
